function stripWhitespace(value: string): string {
  return value.replace(/\s+/g, '');
}

function luhnValid(digits: string): boolean {
  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    let d = digits.charCodeAt(i) - 48;
    if (i % 2 === 0) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
}

export function isValidSwedishOrganizationNumber(value: string): boolean {
  const cleaned = stripWhitespace(value);
  const match = /^(\d{6})-?(\d{4})$/.exec(cleaned);
  if (!match) return false;

  const digits = match[1] + match[2];
  const groupDigit = digits.charCodeAt(2) - 48;
  if (groupDigit < 2) return false;

  return luhnValid(digits);
}

export function isValidSwedishBankAccount(value: string): boolean {
  const cleaned = stripWhitespace(value);
  const match = /^(\d+)-(\d+)$/.exec(cleaned);
  if (!match) return false;

  const [, prefix, suffix] = match;

  if (isValidBankgiro(prefix, suffix)) return true;
  if (isValidPlusgiro(prefix, suffix)) return true;
  if (isValidKontonummer(prefix, suffix)) return true;

  return false;
}

function isValidBankgiro(prefix: string, suffix: string): boolean {
  if (suffix.length !== 4) return false;
  if (prefix.length !== 3 && prefix.length !== 4) return false;
  return luhnValid(prefix + suffix);
}

function isValidPlusgiro(prefix: string, suffix: string): boolean {
  if (suffix.length !== 1) return false;
  const totalDigits = prefix.length + suffix.length;
  if (totalDigits < 2 || totalDigits > 8) return false;
  return luhnValid(prefix + suffix);
}

function isValidKontonummer(prefix: string, suffix: string): boolean {
  if (prefix.length !== 4 && prefix.length !== 5) return false;
  if (suffix.length < 2 || suffix.length > 10) return false;
  return true;
}
